import { RootAppState } from 'store/configureStore'

export const projectBuyerSelector = (state: RootAppState) => {
  return state.project?.activeProject?.buyingParty
}
